import React, { useState, useEffect, useRef } from 'react';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { authStore } from '../../api/client';
import { logout as apiLogout } from '../../api/auth';
import BrandLogo from '../ui/BrandLogo';
import { formatRole } from '../../utils/formatters';

export const ShellIcon = ({ name, className = 'w-4 h-4 shrink-0' }) => {
  const paths = {
    dashboard:    <path d="M3 3h7v7H3V3zm11 0h7v7h-7V3zm-11 11h7v7H3v-7zm11 0h7v7h-7v-7z" />,
    openings:     <path d="M20 6h-4V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2H4a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm-8-2h4v2h-4V4zm8 15H4V8h16v11z" />,
    applications: <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm4 18H6V4h7v5h5v11z" />,
    interviews:   <path d="M19 4h-1V2h-2v2H8V2H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 16H5V10h14v10z" />,
    practice:     <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm0-13a5 5 0 1 0 5 5 5 5 0 0 0-5-5zm0 8a3 3 0 1 1 3-3 3 3 0 0 1-3 3z" />,
    profile:      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />,
    settings:     <path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58a.49.49 0 0 0 .12-.61l-1.92-3.32a.488.488 0 0 0-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54a.484.484 0 0 0-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94 0 .31.02.64.07.94l-2.03 1.58a.49.49 0 0 0-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z" />,
    pipeline:     <path d="M4 4h4v16H4V4zm6 0h4v10h-4V4zm6 0h4v6h-4V4z" />,
    candidates:   <path d="M16 11c1.66 0 3-1.34 3-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 3-1.34 3-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5C15 14.17 10.33 13 8 13zm8 0c-.29 0-.62.02-.97.05A5.97 5.97 0 0 1 17 16.5V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />,
    questions:    <path d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z" />,
    reports:      <path d="M5 9.2h3V19H5zM10.6 5h2.8v14h-2.8zm5.6 8H19v6h-2.8z" />,
    billing:      <path d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 4H4V6h16v2zm0 4H4v-2h16v2zm-9 4H4v-2h7v2z" />,
    org:          <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z" />,
    bell:         <path d="M12 22a2 2 0 0 0 2-2h-4a2 2 0 0 0 2 2zm6-6V11a6 6 0 1 0-12 0v5l-2 2v1h16v-1l-2-2z" />,
    menu:         <path d="M3 6h18v2H3zM3 11h18v2H3zM3 16h18v2H3z" />,
    close:        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />,
    logout:       <path d="M16 13v-2H7V8l-5 4 5 4v-3zM20 3h-9c-1.11 0-2 .89-2 2v4h2V5h9v14h-9v-4H9v4c0 1.11.89 2 2 2h9c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2z" />,
    chevron:      <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />,
  };

  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      {paths[name] || paths.dashboard}
    </svg>
  );
};

export default function UnifiedPortalShell({
  portalType = 'candidate', // 'candidate' | 'org'
  navItems = [],
  brandSubtitle,
  breadcrumbPrefix = 'Candidate Portal',
  pageTitle,
  showSearch = false,
  searchQuery = '',
  onSearchChange,
  onSearchSubmit,
  footerCard,
  children,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const user = authStore.user;

  const [mobileOpen, setMobileOpen] = useState(false);
  const [bellOpen, setBellOpen] = useState(false);
  const bellRef = useRef(null);

  // Close mobile drawer on route navigation
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  // Click outside listener for notification bell
  useEffect(() => {
    if (!bellOpen) return;
    const handleClick = (e) => {
      if (bellRef.current && !bellRef.current.contains(e.target)) {
        setBellOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [bellOpen]);

  const handleSignOut = async () => {
    try {
      if (authStore.refreshToken) {
        await apiLogout({ refreshToken: authStore.refreshToken });
      }
    } catch (err) {
      console.warn('[UnifiedShell] logout failed:', err.message);
    } finally {
      authStore.clear();
      navigate('/login', { replace: true });
    }
  };

  // Derive page title if not explicitly supplied
  const resolvedTitle =
    pageTitle ||
    navItems.find(
      (item) =>
        item.to === location.pathname ||
        (item.to !== '/candidate' &&
          item.to !== '/dashboard' &&
          location.pathname.startsWith(item.to))
    )?.label ||
    'Dashboard';

  // Avatar initials
  const initials = (() => {
    if (user?.fullName) {
      const parts = user.fullName.trim().split(/\s+/);
      if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
      return parts[0].slice(0, 2).toUpperCase();
    }
    if (user?.email) return user.email.slice(0, 2).toUpperCase();
    return 'SA';
  })();

  const resolvedSubtitle =
    brandSubtitle ||
    (portalType === 'candidate'
      ? 'CANDIDATE PORTAL'
      : user?.organizationName || user?.orgName || 'ENTERPRISE');

  const displayRole =
    portalType === 'candidate' ? 'Candidate' : formatRole(user?.role);

  const sidebarNode = (
    <aside className="sidebar flex flex-col justify-between">
      <div>
        {/* Brand header */}
        <div className="pb-6 border-b border-white/[0.08]">
          <BrandLogo subtitle={resolvedSubtitle} light />
        </div>

        {/* Navigation list */}
        <nav className="mt-6 space-y-1">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `nav-item ${isActive ? 'active' : ''}`
              }
            >
              <ShellIcon name={item.icon} className="w-[18px] h-[18px]" />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
      </div>

      {/* Footer block (notice card or custom CTA) */}
      <div className="pt-6">
        {footerCard ? (
          footerCard
        ) : portalType === 'candidate' ? (
          <div className="rounded-[14px] p-3.5 bg-white/[0.04] border border-white/[0.08]">
            <p className="text-[12.5px] font-semibold text-white">
              Desktop agent required
            </p>
            <p className="text-[11.5px] text-[#8593a8] mt-1 leading-snug">
              Live interviews and mock practice run through the Samastix desktop app.
            </p>
          </div>
        ) : null}
      </div>
    </aside>
  );

  return (
    <div className="min-h-screen flex bg-[var(--canvas)] text-[var(--ink)]">
      {/* ── Desktop Sidebar Rail ──────────────────────────────────── */}
      <div className="hidden lg:block shrink-0">{sidebarNode}</div>

      {/* ── Mobile Sidebar Drawer ─────────────────────────────────── */}
      {mobileOpen && (
        <div className="lg:hidden fixed inset-0 z-50 flex">
          <button
            type="button"
            aria-label="Close navigation"
            onClick={() => setMobileOpen(false)}
            className="absolute inset-0 bg-[#0e1a30]/60 backdrop-blur-sm"
          />
          <div className="relative w-[260px] max-w-[85vw] h-full z-10 animate-slide-over">
            <button
              type="button"
              onClick={() => setMobileOpen(false)}
              className="absolute top-4 right-4 text-white/70 hover:text-white p-1"
              aria-label="Close menu"
            >
              <ShellIcon name="close" className="w-5 h-5" />
            </button>
            {sidebarNode}
          </div>
        </div>
      )}

      {/* ── Main Content Area ───────────────────────────────────────── */}
      <div className="flex-1 flex flex-col min-w-0">
        {/* Sticky Topbar */}
        <header className="topbar flex items-center justify-between gap-4">
          <div className="flex items-center gap-3 min-w-0 flex-1">
            {/* Mobile menu trigger */}
            <button
              type="button"
              onClick={() => setMobileOpen(true)}
              className="lg:hidden w-9 h-9 rounded-lg flex items-center justify-center text-[var(--ink-soft)] hover:bg-white/60"
              aria-label="Open menu"
            >
              <ShellIcon name="menu" className="w-5 h-5" />
            </button>

            {/* Breadcrumbs */}
            <div className="flex items-center gap-2 text-[13px] min-w-0">
              <span className="text-[var(--ink-faint)] font-medium truncate">
                {breadcrumbPrefix}
              </span>
              <span className="text-[var(--line)]">/</span>
              <span className="text-[var(--ink)] font-semibold truncate">
                {resolvedTitle}
              </span>
            </div>

            {/* Optional Org global search */}
            {showSearch && (
              <form
                onSubmit={onSearchSubmit}
                className="hidden md:flex flex-1 justify-center max-w-md mx-4"
              >
                <input
                  type="search"
                  value={searchQuery}
                  onChange={(e) => onSearchChange && onSearchChange(e.target.value)}
                  placeholder="Search sessions, candidates…"
                  className="input !py-1.5 !text-xs !rounded-full !bg-white/90"
                />
              </form>
            )}
          </div>

          {/* Right actions: Bell + User pill + Sign out */}
          <div className="flex items-center gap-3 shrink-0">
            {/* Notification Bell */}
            <div className="relative" ref={bellRef}>
              <button
                type="button"
                onClick={() => setBellOpen(!bellOpen)}
                className="w-9 h-9 rounded-[10px] bg-white border border-[var(--line)] flex items-center justify-center text-[var(--ink-soft)] hover:text-[var(--ink)] hover:border-[#cbd5e1] transition-colors shadow-sm"
                aria-label="Notifications"
              >
                <ShellIcon name="bell" className="w-4 h-4" />
              </button>

              {bellOpen && (
                <div className="absolute right-0 mt-2 w-72 bg-white rounded-[14px] border border-[var(--line)] shadow-pop p-4 z-50 animate-slide-up">
                  <div className="flex items-center justify-between pb-2 border-b border-[var(--line-soft)]">
                    <p className="text-xs font-bold text-[var(--navy-950)]">
                      Notifications
                    </p>
                    <span className="text-[10px] uppercase font-semibold text-[var(--teal-600)]">
                      All clear
                    </span>
                  </div>
                  <p className="text-xs text-[var(--ink-soft)] pt-3">
                    You have no new notifications.
                  </p>
                </div>
              )}
            </div>

            {/* User pill */}
            <div className="flex items-center gap-2.5 pl-1">
              <div
                className="w-8 h-8 rounded-full flex items-center justify-center font-semibold text-xs text-white shrink-0 shadow-sm"
                style={{
                  background:
                    portalType === 'candidate'
                      ? 'linear-gradient(135deg, #0e9488, #0c7c6f)'
                      : 'linear-gradient(135deg, #132444, #0e1a30)',
                }}
              >
                {initials}
              </div>
              <div className="hidden sm:block leading-tight text-left">
                <p className="text-[13px] font-semibold text-[var(--ink)] truncate max-w-[140px]">
                  {user?.fullName || user?.email?.split('@')[0] || 'User'}
                </p>
                <p className="text-[11px] text-[var(--ink-faint)] truncate">
                  {displayRole}
                </p>
              </div>
            </div>

            {/* Sign out button */}
            <button
              type="button"
              onClick={handleSignOut}
              className="btn btn-ghost !py-1.5 !px-3 !text-xs !rounded-[10px]"
            >
              Sign out
            </button>
          </div>
        </header>

        {/* Page content view */}
        <main className="flex-1 overflow-y-auto page-pad page-y">
          <div className="max-w-[1180px] mx-auto w-full">
            {children || <Outlet />}
          </div>
        </main>
      </div>
    </div>
  );
}
